import { generateActions } from './utils'
import { prefixes } from '../constants/actionPrefixes'

const definitions = {
  setError: ['error'],
}

export default generateActions([prefixes.API_ERROR], definitions)
